import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {BrandHubPageService_GetFilterLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.grpc.lazy';
import {useIsMultiBrand} from '@aboutyou/router';
import {useCategoryIdentifier} from '../../../features/hooks/useCategoryIdentifier';
import {
  useAppliedLiveAtFilter,
  useAppliedPotentialFilters,
} from '../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {
  useBrandShopCacheKeyTransformer,
  useBrandShopIdentifier,
} from './useBrandShopIdentifier';

export const useBrandShopFilters = () => {
  const appliedFilters = useAppliedPotentialFilters();
  const categoryIdentifier = useCategoryIdentifier();
  const liveAtFilter = useAppliedLiveAtFilter();
  const brandShopIdentifier = useBrandShopIdentifier();
  const targetGroupIdentifier = useTargetGroupIdentifier();
  const isMultiBrand = useIsMultiBrand();
  const brandShopCacheKeyTransformer = useBrandShopCacheKeyTransformer();

  return useGrpcRequest(
    BrandHubPageService_GetFilterLazy,
    {
      brand: {
        identifier: brandShopIdentifier,
      },
      targetGroup: targetGroupIdentifier,
      appliedFilters: {
        filters: appliedFilters,
        liveAt: liveAtFilter
          ? {
              minDate: liveAtFilter,
            }
          : undefined,
      },
      category: categoryIdentifier ?? null,
      isMultiBrand,
      reductionsState: useReductionsStateRequestParameter(),
    },
    {
      keepPreviousData: true,
      transformCacheKey: brandShopCacheKeyTransformer,
    },
  );
};
